module.exports = __webpack_public_path__ + "img/crayons.d12c69e1.png";